import { GetterTree, Module, MutationTree } from "vuex";
import { RootState } from "@/stores";
import { GoogleAuthResponse, UserProfile } from "@/types";
import * as actions from "./actions";
import utils from "@/utils/auth-utils";

export interface AuthState {
  auth: GoogleAuthResponse | null;
  user: UserProfile | null;
  /* This is the Interval ID the checks the auth status of user */
  monitorId: number | null;
}

const getInitialState = (): AuthState => {
  return {
    auth: null,
    user: null,
    monitorId: null,
  };
};

const initialState: AuthState = getInitialState();

const getters: GetterTree<AuthState, RootState> = {
  sessionExpiredAt: (state: AuthState): number => {
    return state.auth?.expires_at || 0;
  },
  isTokenExpired: (state: AuthState): boolean => {
    if (!state.auth) return true;
    return utils.isTokenExpired(state.auth.expires_at);
  },
  isAuthenticated: (state: AuthState, getters: any): boolean => {
    if (!state.auth) return false;
    return Boolean(state.auth.access_token) && !getters.isTokenExpired;
  },
  getLoginUserInfo: (state: AuthState): UserProfile | null => {
    return state.user;
  },
};

const mutations: MutationTree<AuthState> = {
  setAuth(state: AuthState, payload: GoogleAuthResponse) {
    state.auth = payload;
  },
  setUser(state: AuthState, user: UserProfile) {
    state.user = user;
  },
  setMonitorId(state: AuthState, monitorId: number) {
    state.monitorId = monitorId;
  },
  resetState(state: AuthState) {
    Object.assign(state, getInitialState());
  },
};

const auth: Module<AuthState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export default auth;
